import React from "react";

import gubernamentalesPC from "../Assets/industrias/seccionuno/gubernamentalespc.jpg";
import gubernamentalesLap from "../Assets/industrias/seccionuno/gubernamentaleslaptop.jpg";
import gubernamentalesTab from "../Assets/industrias/seccionuno/gubernamentalestablet.jpg";
import gubernamentalesCel from "../Assets/industrias/seccionuno/gubernamentalescelu.jpg";
import gubernamentalesMini from "../Assets/industrias/seccionuno/gubernamentalespeque.jpg";

import industrialPC from "../Assets/industrias/seccionuno/industrialpc.jpg";
import industrialLap from "../Assets/industrias/seccionuno/industriallaptop.jpg";
import industrialTab from "../Assets/industrias/seccionuno/industrialtablet.jpg";
import industrialCel from "../Assets/industrias/seccionuno/industrialcelu.jpg";
import industrialMini from "../Assets/industrias/seccionuno/industrialpeque.jpg";

import serviciosPC from "../Assets/industrias/seccionuno/serviciospc.jpg";
import serviciosLap from "../Assets/industrias/seccionuno/servicioslaptop.jpg";
import serviciosTab from "../Assets/industrias/seccionuno/serviciostablet.jpg";
import serviciosCel from "../Assets/industrias/seccionuno/servicioscelu.jpg";
import serviciosMini from "../Assets/industrias/seccionuno/serviciospeque.jpg";

import financieraPC from "../Assets/industrias/seccionuno/financierapc.jpg";
import financieraLap from "../Assets/industrias/seccionuno/financieralaptop.jpg";
import financieraTab from "../Assets/industrias/seccionuno/financieratablet.jpg";
import financieraCel from "../Assets/industrias/seccionuno/financieracelu.jpg";
import financieraMini from "../Assets/industrias/seccionuno/financierapeque.jpg";

import tecnologicasPC from "../Assets/industrias/seccionuno/tecnologicaspc.jpg";
import tecnologicasLap from "../Assets/industrias/seccionuno/tecnologicaslaptop.jpg";
import tecnologicasTab from "../Assets/industrias/seccionuno/tecnologicastablet.jpg";
import tecnologicasCel from "../Assets/industrias/seccionuno/tecnologicascelu.jpg";
import tecnologicasMini from "../Assets/industrias/seccionuno/tecnologicaspeque.jpg";

import estrategicasPC from "../Assets/industrias/seccionuno/estrategicaspc.jpg";
import estrategicasLap from "../Assets/industrias/seccionuno/estrategicaslaptop.jpg";
import estrategicasTab from "../Assets/industrias/seccionuno/estrategicastablet.jpg";
import estrategicasCel from "../Assets/industrias/seccionuno/estrategicascelu.jpg";
import estrategicasMini from "../Assets/industrias/seccionuno/estrategicaspeque.jpg";

import turismoPC from "../Assets/industrias/seccionuno/turismopc.jpg";
import turismoLap from "../Assets/industrias/seccionuno/turismolaptop.jpg";
import turismoTab from "../Assets/industrias/seccionuno/turismotablet.jpg";
import turismoCel from "../Assets/industrias/seccionuno/turismocelu.jpg";
import turismoMini from "../Assets/industrias/seccionuno/turismopeque.jpg";

import osfPC from "../Assets/industrias/seccionuno/osflpc.jpg";
import osfLap from "../Assets/industrias/seccionuno/osfllaptop.jpg";
import osfTab from "../Assets/industrias/seccionuno/osfltablet.jpg";
import osfCel from "../Assets/industrias/seccionuno/osflcelu.jpg";
import osfMini from "../Assets/industrias/seccionuno/osflpeque.jpg";
const IndustriesContext = React.createContext();

function IndustriesProvider(props) {
  const industries = [
    {
      title: "Gubernamentales",

      text: [
        "Delta Consult ha sido un socio de confianza para numerosas empresas gubernamentales en Bolivia durante más de cuatro décadas. Nuestra experiencia en esta área se extiende desde la realización de auditorías precisas y conformes con los requisitos gubernamentales hasta la consultoría estratégica que ayuda a mejorar la eficiencia y la transparencia en la gestión pública. ",

        "Asimismo desarrollamos auditorías especiales con el fin de luchar contra la corrupción y evitar la malversación de los recursos del Estado.",
      ],
      imagen: [
        gubernamentalesPC,
        gubernamentalesLap,
        gubernamentalesTab,
        gubernamentalesCel,
      ],
      mini: gubernamentalesMini,
    },

    {
      title: "Industriales y comerciales",

      text: [
        "En el ámbito industrial y comercial, Delta Consult ha demostrado su capacidad para adaptarse a las necesidades de una amplia gama de sectores. Desde la manufactura hasta la distribución, trabajamos en estrecha colaboración con empresas para optimizar sus operaciones, mejorar la rentabilidad y garantizar el cumplimiento normativo. ",

        "Nuestra experiencia abarca desde la evaluación de procesos y la gestión de riesgos hasta la implementación de estrategias de crecimiento.",
      ],
      imagen: [
        industrialPC,
        industrialLap,
        industrialTab,
        industrialCel,
        industrialMini,
      ],
      mini: industrialMini,
    },

    {
      title: "Empresas de servicios",

      text: [
        "Las empresas de servicios enfrentan desafíos únicos en un entorno competitivo. Brindamos soluciones específicas para este sector, ayudando a empresas de servicios a mejorar la eficiencia operativa, la gestión de la calidad y la satisfacción del cliente. ",

        "Ya sea en el ámbito de la educación, la salud, la tecnología, turismo  o cualquier otro servicio, nuestra experiencia en consultoría y auditoría permite a las empresas de servicios elevar sus estándares y lograr resultados sobresalientes.",
      ],
      imagen: [
        serviciosPC,
        serviciosLap,
        serviciosTab,
        serviciosCel,
        serviciosMini,
      ],
      mini: serviciosMini,
    },

    {
      title: "Financieras y de seguros",

      text: [
        "Las empresas financieras y de seguros confían en Delta Consult para mantener la transparencia, la solidez financiera y la gestión de riesgos. Nuestros servicios abarcan desde la auditoría de estados financieros hasta la consultoría en cumplimiento normativo y gestión de riesgos. ",

        "Colaboramos con bancos, aseguradoras y otras instituciones financieras para ayudarles a mantener un ambiente de control interno adecuado con sus niveles de riesgos, la confianza de sus clientes y reguladores, además de promover un crecimiento sostenible en el sector.",
      ],
      imagen: [
        financieraPC,
        financieraLap,
        financieraTab,
        financieraCel,
        financieraMini,
      ],
      mini: financieraMini,
    },
    {
      title: "Tecnológicas",

      text: [
        "Las empresas tecnológicas deben aprovechar el poder de la transformación y crecer con escala y velocidad, al mismo tiempo que satisfagan las expectativas del cliente del futuro.",

        "Para abordar esto, nuestro equipo global de estrategas comerciales, tecnólogos y líderes de la industria aporta nuevas ideas y conocimientos sectoriales en el sector de la tecnología para brindar a nuestros clientes brindar valores estratégicos a largo plazo en sus servicios.",
      ],
      imagen: [
        tecnologicasPC,
        tecnologicasLap,
        tecnologicasTab,
        tecnologicasCel,
        tecnologicasMini,
      ],
      mini: tecnologicasMini,
    },

    {
      title: "Estratégicas",

      text: [
        "Las empresas estratégicas desempeñan un papel crucial en el desarrollo económico del país. En Delta Consult, brindamos servicios de consultoría estratégica para ayudar a estas empresas a identificar oportunidades de crecimiento, mejorar la eficiencia operativa y tomar decisiones sólidas. ",

        "Nuestra experiencia en este sector nos permite colaborar estrechamente con las empresas estratégicas de nuestro país, para apoyar a alcanzar los objetivos a largo plazo y contribuir aún más con el desarrollo económico de Bolivia.",
      ],
      imagen: [
        estrategicasPC,
        estrategicasLap,
        estrategicasTab,
        estrategicasCel,
        estrategicasMini,
      ],
      mini: estrategicasMini,
    },

    {
      title: "Sin fines de lucro",

      text: [
        "Las organizaciones sin fines de lucro desempeñan un papel fundamental en la sociedad y el respeto de sus derechos, y en Delta Consult, apoyamos su misión brindando servicios de auditoría y consultoría especializados. ",

        "Trabajamos en estrecha colaboración con estas organizaciones para garantizar la transparencia financiera, cumplir con los requisitos regulatorios y maximizar su impacto social. ",
      ],
      imagen: [osfPC, osfLap, osfTab, osfCel, osfMini],
      mini: osfMini,
    },
    {
      title: "Turismo y gastronomía",

      text: [
        "Delta Consult trabaja con empresas para impulsar la calidad de los servicios, la eficiencia operativa y la satisfacción del cliente. Nuestros servicios van desde la evaluación de la gestión de costos hasta la implementación de estrategias de marketing. ",

        "Colaboramos con distintas empresas de este sector, hoteles, restaurantes, y empresas turísticas para ayudarles a sobresalir en un mercado competitivo y atraer a visitantes y clientes de manera efectiva.",
      ],
      imagen: [turismoPC, turismoLap, turismoTab, turismoCel, turismoMini],
      mini: turismoMini,
    },
  ];
  return (
    <IndustriesContext.Provider value={{ industries }}>
      {props.children}
    </IndustriesContext.Provider>
  );
}

export { IndustriesContext, IndustriesProvider };
